import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "\u6D88\u606F\u63D0\u9192\u7EBF\u6027"
});
const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.9999 1.33325C11.1999 1.33325 10.5666 1.96659 10.5666 2.76659V3.39992C7.56657 4.06659 5.2999 6.73325 5.2999 9.93325V16.5999H3.8999C3.63324 16.5999 3.3999 16.8333 3.3999 17.0999V17.9999C3.3999 18.2666 3.63324 18.4999 3.8999 18.4999H5.2999H18.6666H20.0666C20.3332 18.4999 20.5666 18.2666 20.5666 17.9999V17.0999C20.5666 16.8333 20.3332 16.5999 20.0666 16.5999H18.6666V9.93325C18.6666 6.73325 16.4332 4.06659 13.4332 3.39992V2.76659C13.4332 1.99992 12.7666 1.33325 11.9999 1.33325ZM16.7666 9.93325V16.5999H7.1999V9.93325V9.73325C7.33324 7.19992 9.43324 5.16659 11.9999 5.16659H12.1999C14.7332 5.26659 16.7666 7.36658 16.7666 9.93325Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.9668 19.8667C14.9668 21.5 13.6668 22.8 12.0334 22.8C10.4001 22.8 9.1001 21.5 9.1001 19.8667H14.9668Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
var _______ = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { _______ as default };
